import React from 'react';
import { IBaseAction } from '@models/actions/IBaseAction';
import { DocBaseActionExecutor } from '@organisms/actions/DocBaseActionExecutor';
import { ModalSize } from '@/types/ModalSize';
import { ICreateDocByTemplateDialogExecutorProps } from './ICreateDocByTemplateDialogExecutorProps';
import { CreateDocByTemplateDialogExecutorModal } from './CreateDocByTemplateDialogExecutorModal';

export class CreateDocByTemplateDialogExecutor extends DocBaseActionExecutor {
    private _modalProps?: ICreateDocByTemplateDialogExecutorProps;

    runInternal = (
        objId: string,
        parentId: string | undefined,
        action: IBaseAction,
        rowData?: any,
        completeHandler?: (isSucceed: boolean) => void,
        modalSize?: ModalSize | null,
    ) => {
        this._modalProps = {
            docId: objId ?? '',
            actionKey: action.key ?? '',
            title: action.options?.title ?? '',
            okButtonText: action.options?.okButtonText ?? 'ОК',
            cancelButtonText: action.options?.cancelButtonText ?? 'Отмена',
            modalSize: modalSize ?? action.options?.modalSize ?? 'xl',
            completeHandler: completeHandler,
        };
    };

    visualElementInner = () => {
        return this._modalProps ? <CreateDocByTemplateDialogExecutorModal {...this._modalProps} /> : <div />;
    };
}
